
                  export default function (Component) {
                      Component.__source = "library/components/VabFooter/index.vue"
                  }
              